import Image from 'components/Image';

export default function DestinationImage({ image, isPrio }) {
  return (
    <div className="tw-min-h-[200px]">
      <Image
        src={image.url}
        layout="fill"
        className="tw-object-cover tw-object-center tw-rounded-xl"
        alt={image.alt}
        blurDataURL={image.blur}
        placeholder={image.blur ? 'blur' : undefined}
        priority={isPrio}
      />
      <div className="tw-rounded-b-xl -tw-ml-4 tw-h-28 tw-w-full tw-z-10 tw-absolute tw-bottom-0 tw-bg-gradient-to-t tw-from-black">
        <div className="tw-absolute tw-bottom-0 tw-p-2">{image.alt}</div>
      </div>
    </div>
  );
}
